import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { IRespApi } from '@appNeo/neoShared/helpers/interfaces/IResp-api';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { UtilidadesCrudService } from '@appNeo/neoShared/services/utilidades/utilidades-crud.service';
import { Observable, catchError, forkJoin, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CodigosDescuentoService extends UtilidadesCrudService {

  constructor(http: HttpClient, auxiliar: AuxiliarService) {
    super(
      http,
      auxiliar,
      'descuentos',
      'descuentos',
      'Descuento',
      'Descuentos',
      [
        'id',
        'fechaInicio',
        'fechaFin',
        'porcentaje'
      ]
    );
  }
  
  comprobarDescuento(datos): Observable<any> {
    return this.http.post(`${this.urlEntidades}/comprobarDescuento`, datos, { ...this.contextLoaderTransparent })
    .pipe(
        map((data: IRespApi) => this.mapearEntidad(data['data'])),
        catchError((err: IRespApi) => {
            return this.handleError(err, `IRequestGet${this.identificadorEntidad}`);
        })
    );
}

  /************************************ 
   * Funciones apoyo                  *
  *************************************/
 resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
   let peticion = {
    listadoEntidad: this.getAll().pipe(
      catchError(err => of(null))
      )
    };
    
    return forkJoin(peticion);
  }
}